export function EmailCustomerStatementCtrl (
  $scope,
  companyMessages,
  customer,
  inheritorApi
) {
  $scope.companyMessages = companyMessages;
  $scope.customer        = customer;

  inheritorApi.inheritCtrl('EmailCustomerStatementLiteCtrl', $scope);
}
